/**
 * Shadow Tokens - Fluent 2 Style
 * Single-layer, soft shadows with low opacity
 */

export const baseShadows = {
  none: 'none',
  xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  sm: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
  lg: '0 8px 16px 0 rgba(0, 0, 0, 0.10)',
  xl: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',

  // MUI elevation mapping (0-24)
  elevation: {
    0: 'none',
    1: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    2: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    4: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
    8: '0 8px 16px 0 rgba(0, 0, 0, 0.10)',
    16: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    24: '0 24px 48px 0 rgba(0, 0, 0, 0.14)'
  }
} as const;
